import { isPresent } from '@grandvisionhq/utils';
import { getFrameMeasurements } from '../../utils/get-frame-measurements.js';

const getSharedFrameVariantProps = ({ frameFeatures , lensFeatures , faceShape  })=>{
    var ref;
    const { bridgeWidth , color: frameColor , width: frameWidth , size: frameSize , templeLength ,  } = frameFeatures !== null && frameFeatures !== void 0 ? frameFeatures : {};
    const { lensColor , lensHeight , lensWidth  } = lensFeatures !== null && lensFeatures !== void 0 ? lensFeatures : {};
    const frameColorName = Array.isArray(frameColor) ? frameColor.join(' / ') : frameColor;
    const colorFacet = [
        lensColor,
        frameColorName
    ].filter(Boolean).join(' / ');
    const frameMeasurements = getFrameMeasurements(bridgeWidth, frameWidth, lensHeight, lensWidth, templeLength);
    const faceShapes = (ref = faceShape.map(({ shape  })=>{
        return shape === null || shape === void 0 ? void 0 : shape.toLocaleLowerCase();
    })) === null || ref === void 0 ? void 0 : ref.filter(isPresent);
    var ref1;
    return {
        facets: {
            color: !!colorFacet ? colorFacet : undefined,
            size: (ref1 = frameSize === null || frameSize === void 0 ? void 0 : frameSize.size) !== null && ref1 !== void 0 ? ref1 : undefined
        },
        frameMeasurements,
        faceShapes
    };
};

export { getSharedFrameVariantProps };
//# sourceMappingURL=get-shared-frame-variant-props.js.map
